export default __webpack_public_path__ + "static/heatmaps-e8358f6a977e392477188b13cd0cbd91.png";